import React from 'react';
import { PROCEDURE_IDS } from '@zocdoc-frontend-common/utils-constants';
import { AppointmentStackingErrorDescription } from './AppointmentStackingErrorDescription';
import { MODAL_STRINGS } from './constants';
import { ErrorModalDescription } from './ErrorModalDescription';
import { MaxAppointmentErrorDescription } from './MaxAppointmentErrorDescription';
import { SyncErrorModalDescription } from './SyncErrorModalDescription';

export const genericErrorModalContent = ({ handlePrimaryButtonClick }) => ({
    ariaLabel: 'booking error pop up',
    modalName: 'Generic Error Modal',
    headerText: MODAL_STRINGS.SomethingWentWrong,
    descriptionText: <ErrorModalDescription />,
    primaryButtonText: MODAL_STRINGS.OK,
    onClickPrimaryButton: () => handlePrimaryButtonClick(),
    gaAction: 'Show Booking Submit Error Modal',
    trackingMessage: MODAL_STRINGS.SomethingWentWrong,
});

export const customErrorModalContent = ({
    handlePrimaryButtonClick,
    descriptionText,
}) => ({
    ariaLabel: 'booking error pop up',
    modalName: 'Custom Error Modal',
    headerText: descriptionText,
    primaryButtonText: MODAL_STRINGS.OK,
    onClickPrimaryButton: () => handlePrimaryButtonClick(),
    gaAction: 'Show Booking Submit Error Modal',
    trackingMessage: descriptionText,
});

export const syncFailureModalContent = ({
    handlePrimaryButtonClick,
    phoneNumber,
}) => ({
    ariaLabel: 'booking error pop up',
    modalName: 'Sync Failure Error Modal',
    headerText: MODAL_STRINGS.UnableToBook,
    descriptionText: <SyncErrorModalDescription phoneNumber={phoneNumber} />,
    primaryButtonText: MODAL_STRINGS.BackToHome,
    onClickPrimaryButton: () => handlePrimaryButtonClick(),
    gaAction: MODAL_STRINGS.UnableToBook,
});

export const appointmentTimeErrorModalContent = ({
    handlePrimaryButtonClick,
}) => ({
    ariaLabel: 'booking error pop up',
    modalName: 'Appointment No Longer Available Error Modal',
    headerText: MODAL_STRINGS.AppointmentNoLongerAvailable,
    descriptionText: MODAL_STRINGS.PleaseSelectANewTime,
    primaryButtonText: MODAL_STRINGS.OK,
    onClickPrimaryButton: () => handlePrimaryButtonClick(),
    gaAction: MODAL_STRINGS.AppointmentNoLongerAvailable,
});

export const patientTimesOverlapErrorModalContent = ({
    handlePrimaryButtonClick,
}) => ({
    ariaLabel: 'booking error pop up',
    modalName: 'Appointment Times Overlap Error Modal',
    headerText: MODAL_STRINGS.PatientTimesOverlap,
    descriptionText: MODAL_STRINGS.PleaseSelectAnotherTime,
    primaryButtonText: MODAL_STRINGS.OK,
    onClickPrimaryButton: () => handlePrimaryButtonClick(),
    gaAction: 'Show Booking Submit Error Modal',
    trackingMessage: MODAL_STRINGS.PatientTimesOverlap,
});

export const phoneIsVerifiedFailureErrorModalContent = ({
    handlePrimaryButtonClick,
}) => ({
    ariaLabel: 'booking error pop up',
    modalName: 'Verify Phone Number Error Modal',
    headerText: MODAL_STRINGS.PhoneIsVerifiedFailure,
    primaryButtonText: MODAL_STRINGS.OK,
    onClickPrimaryButton: () => handlePrimaryButtonClick(),
    gaAction: 'Show Booking Submit Error Modal',
    trackingMessage: MODAL_STRINGS.PhoneIsVerifiedFailure,
});

export const appointmentStackingErrorModalContent = ({
    handlePrimaryButtonClick,
    patientId,
}) => ({
    ariaLabel: 'booking error pop up',
    modalName: 'Appointment Stacking Error Modal',
    headerText: MODAL_STRINGS.NotCompleted,
    descriptionText: (
        <AppointmentStackingErrorDescription patientId={patientId} />
    ),
    primaryButtonText: MODAL_STRINGS.ViewUpcomingAppointments,
    onClickPrimaryButton: () => handlePrimaryButtonClick(),
    gaAction: MODAL_STRINGS.NotCompleted,
    trackingMessage: MODAL_STRINGS.NotCompleted,
});

export const didYouStepAwayModalContent = ({ handlePrimaryButtonClick }) => ({
    ariaLabel: 'booking error pop up',
    modalName: 'Stepped Away Error Modal',
    headerText: MODAL_STRINGS.PleaseReenterYourInformation,
    descriptionText: MODAL_STRINGS.YouSteppedAway,
    primaryButtonText: MODAL_STRINGS.OK,
    onClickPrimaryButton: () => handlePrimaryButtonClick(),
    gaAction: MODAL_STRINGS.YouSteppedAway,
});

export const appointmentAlreadySubmittedModalContent = ({
    handlePrimaryButtonClick,
    handleSecondaryButtonClick,
}) => ({
    ariaLabel: 'booking error pop up',
    modalName: 'Appointment Already Submitted Error Modal',
    headerText: MODAL_STRINGS.AppointmentAlreadyBooked,
    descriptionText: MODAL_STRINGS.GoToAccountsPage,
    primaryButtonText: MODAL_STRINGS.ViewUpcomingAppointments,
    secondaryButtonText: MODAL_STRINGS.Close,
    onClickPrimaryButton: () => handlePrimaryButtonClick(),
    onClickSecondaryButton: () => handleSecondaryButtonClick(),
    gaAction: MODAL_STRINGS.AppointmentAlreadyBooked,
});

export const maxAppointmentsReachedModalContent = ({
    handlePrimaryButtonClick,
    handleSecondaryButtonClick,
}) => ({
    ariaLabel: 'booking error pop up',
    modalName: 'Max Appointments Reached Error Modal',
    headerText: MODAL_STRINGS.YouveReachedMaximumAppointments,
    descriptionText: <MaxAppointmentErrorDescription />,
    primaryButtonText: MODAL_STRINGS.ViewUpcomingAppointments,
    secondaryButtonText: MODAL_STRINGS.Close,
    onClickPrimaryButton: () => handlePrimaryButtonClick(),
    onClickSecondaryButton: () => handleSecondaryButtonClick(),
});

export const maxVaccineAppointmentsReachedModalContent = ({
    handlePrimaryButtonClick,
    handleSecondaryButtonClick,
    procedureId,
}) => {
    const headerText =
        procedureId === PROCEDURE_IDS.COVID_19_VACCINE_DOSE_1
            ? MODAL_STRINGS.MaximumVaccineAppointmentHeaderDose1
            : procedureId === PROCEDURE_IDS.COVID_19_VACCINE_DOSE_2
            ? MODAL_STRINGS.MaximumVaccineAppointmentHeaderDose2
            : MODAL_STRINGS.MaximumVaccineAppointmentHeaderBooster;

    return {
        ariaLabel: 'booking error pop up',
        modalName: 'Max Vaccine Appointments Reached Error Modal',
        headerText,
        descriptionText: MODAL_STRINGS.MaximumVaccineAppointmentBody,
        primaryButtonText: MODAL_STRINGS.ViewUpcomingAppointments,
        secondaryButtonText: MODAL_STRINGS.Close,
        onClickPrimaryButton: () => handlePrimaryButtonClick(),
        onClickSecondaryButton: () => handleSecondaryButtonClick(),
    };
};
